import { FiMediaBankFileModel } from '@fi-shared/models';

export class MediaBankFileModel extends FiMediaBankFileModel {
    //Properties used on client side
    IsEditMode = false;
    PercentageLoaded = 0;
    PercentageProcessed = 0;

    $$uploadPogress: {
        abort: () => void;
    };
    Image?;
    ImageLarge?;
}
